package learning.containers


import com.jingfangpai.api.clients.ContentApiClient
import com.jingfangpai.common.orm.mapping.enums.ContentType
import react.*
import react.dom.div
import setTitle
import learning.components.GuidelineEdit

external interface GuidelineEditPageProps : RProps {
    var id:String
}

data class GuidelineEditPageContextData(
    var saveContent:(content:com.jingfangpai.common.orm.mapping.Content, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.content.model.ContentVo>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit,
    var getContent:(type: ContentType, id:kotlin.String, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.content.model.ContentVo>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit
)

val GuidelineEditPageContext = createContext(GuidelineEditPageContextData(ContentApiClient::saveContent,ContentApiClient::getContent))

val GuidelineEditPageProvider = functionalComponent<GuidelineEditPageProps> { props ->

    setTitle("指引内容编辑")

    fun placeHolderFunction(param: String) {
        console.log("doing something with param")
    }

    useEffectOnce { }

    GuidelineEditPageContext.Provider(GuidelineEditPageContextData(ContentApiClient::saveContent,ContentApiClient::getContent)) {
        div("GuidelineEditPage-content") {
            child(GuidelineEdit) {
                attrs{
                    id = props.id
                }
            }
        }
    }
}
